(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shadow-product-size-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shadow-product-fit')) {
  customElements.define('shadow-product-fit', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-shadow-open]');
      const root = this.querySelector('.ss-size-guide');
      this.trigger.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('shadow-product-fit-open');
      });
      this.querySelectorAll('[data-shadow-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', (event) => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.releaseScroll();
        if (this.isConnected) this.trigger.focus({preventScroll:true});
      });
  const sizes = ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
  const widths = [17.5,19,20.5,22,24,26,28,30,32,34];
  const ranges = [[32,35],[35,38],[38,41],[41,44],[44,48],[48,52],[52,56],[56,60],[60,64],[64,68]];
  let method = 'body', fit = 'regular', unit = 'in', build = 'average';
  const get = (selector) => root.querySelector(selector);
  const field = get('[data-shadow-input]');
  const label = get('[data-shadow-input-label]');
  const help = get('[data-shadow-helper]');
  const out = get('[data-shadow-result-size]');
  const note = get('[data-shadow-result-note]');
  const feet = get('[data-shadow-feet]');
  const inches = get('[data-shadow-inches]');
  const cmHeight = get('[data-shadow-height-cm]');
  const weight = get('[data-shadow-weight]');
  const round1 = v => Math.round(v * 10) / 10;
  const show = v => (unit === 'in' ? String(v) : String(round1(v * 2.54))) + (unit === 'in' ? '″' : ' cm');

  function syncUnits(oldUnit, newUnit) {
    if (oldUnit === newUnit) return;
    if (field.value.trim() && Number.isFinite(Number(field.value))) {
      const number = Number(field.value);
      field.value = String(round1(newUnit === 'cm' ? number * 2.54 : number / 2.54));
    }
    if (oldUnit === 'in') {
      const ft = Number(feet.value);
      const inc = inches.value.trim() === '' ? 0 : Number(inches.value);
      if (feet.value.trim() && Number.isFinite(ft) && Number.isFinite(inc)) {
        cmHeight.value = String(Math.round((ft * 12 + inc) * 2.54));
      }
    } else {
      if (cmHeight.value.trim() && Number.isFinite(Number(cmHeight.value))) {
        let totalInches = Math.round(Number(cmHeight.value) / 2.54);
        feet.value = String(Math.floor(totalInches / 12));
        inches.value = String(totalInches % 12);
      }
    }
    if (weight.value.trim() && Number.isFinite(Number(weight.value))) {
      const current = Number(weight.value);
      weight.value = String(round1(newUnit === 'cm' ? current / 2.20462262 : current * 2.20462262));
    }
  }

  function syncControls() {
    ['data-shadow-measure','data-shadow-fit','data-shadow-unit','data-shadow-build'].forEach(attr => {
      const expected = attr === 'data-shadow-measure' ? method : attr === 'data-shadow-fit' ? fit : attr === 'data-shadow-build' ? build : unit;
      root.querySelectorAll('[' + attr + ']').forEach(button => {
        const active = button.getAttribute(attr) === expected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    });
    get('[data-shadow-chest-fields]').hidden = method === 'height';
    get('[data-shadow-height-fields]').hidden = method !== 'height';
    get('[data-shadow-imperial-height]').hidden = unit !== 'in';
    get('[data-shadow-metric-height]').hidden = unit !== 'cm';
    get('[data-shadow-weight-unit]').textContent = unit === 'in' ? 'lb' : 'kg';
    field.placeholder = method === 'body' ? (unit === 'in' ? 'e.g. 42' : 'e.g. 107') : (unit === 'in' ? 'e.g. 22' : 'e.g. 56');
    label.textContent = (method === 'body' ? 'Chest circumference' : 'Flat chest width') + ' (' + (unit === 'in' ? 'inches' : 'cm') + ')';
    help.textContent = method === 'body'
      ? 'Measure around the fullest part of your chest, keeping the tape level.'
      : 'Lay your best-fitting tee flat and measure across, roughly 1 inch below the armholes.';
  }

  function renderChart() {
    root.querySelectorAll('[data-shadow-measurement]').forEach(cell => {
      cell.textContent = show(Number(cell.dataset.shadowMeasurement));
    });
    root.querySelectorAll('[data-shadow-range]').forEach(cell => {
      const parts = cell.dataset.shadowRange.split('–').map(Number);
      cell.textContent = show(parts[0]) + '–' + show(parts[1]);
    });
  }

  function estimateFromMeasurements() {
    if (!field.value.trim() || !Number.isFinite(Number(field.value)) || Number(field.value) <= 0) return null;
    const inch = unit === 'cm' ? Number(field.value) / 2.54 : Number(field.value);
    let index = -1;
    if (method === 'body') {
      if (inch >= 32 && inch <= 68) index = ranges.findIndex(([min,max],i) => inch >= min && (inch < max || (i === ranges.length - 1 && inch <= max)));
    } else if (inch >= 16.5 && inch <= 35) {
      let best = Infinity;
      widths.forEach((width,i) => {
        const diff = Math.abs(inch-width);
        if (diff < best) { best = diff; index = i; }
      });
    }
    return {index, valid: true, source: method === 'body' ? 'your measured chest' : 'your favorite shirt'};
  }

  function estimateFromHeightWeight() {
    const heightInches = unit === 'in'
      ? ((feet.value.trim() && Number.isFinite(Number(feet.value)) && Number.isFinite(Number(inches.value || '0')))
        ? Number(feet.value) * 12 + Number(inches.value || '0') : NaN)
      : (cmHeight.value.trim() ? Number(cmHeight.value) / 2.54 : NaN);
    const weightLb = weight.value.trim() ? Number(weight.value) * (unit === 'cm' ? 2.20462262 : 1) : NaN;
    if (!Number.isFinite(heightInches) || !Number.isFinite(weightLb)) return null;
    if (unit === 'in' && (Number(inches.value || '0') < 0 || Number(inches.value || '0') > 11)) return {index:-1, valid:false};
    if (heightInches < 54 || heightInches > 84 || weightLb < 80 || weightLb > 500) return {index:-1, valid:false};


    const normalized = weightLb * 70 / heightInches;
    const boundaries = [115,145,175,205,240,285,330,375,420];
    let index = boundaries.findIndex(threshold => normalized < threshold);
    if (index === -1) index = sizes.length - 1;
    if (build === 'broad') index = Math.min(index + 1, sizes.length - 1);
    return {index, valid:true, source:'height and weight (rough estimate)', tall:heightInches >= 74};
  }

  function renderFinder() {
    root.querySelectorAll('[data-shadow-size]').forEach(row => row.classList.remove('is-recommended'));
    const data = method === 'height' ? estimateFromHeightWeight() : estimateFromMeasurements();
    if (data === null) {
      out.textContent = '—';
      note.textContent = method === 'height' ? 'Enter your height and weight to get a rough starting size.' : 'Enter a measurement above to find your starting size.';
      return;
    }
    if (!data.valid || data.index < 0) {
      out.textContent = 'Check chart';
      note.textContent = method === 'height'
        ? 'Please check your height and weight entries (adult range: 4′6″–7′0″ and 80–500 lb). For unusual fits, measure a tee or contact us.'
        : 'This measurement falls outside the chart. Compare garment dimensions or contact us for help.';
      return;
    }
    const index = Math.min(data.index + (fit === 'relaxed' ? 1 : 0), sizes.length - 1);
    out.textContent = sizes[index];
    if (method === 'height') {
      const next = index < sizes.length-1 ? sizes[index + 1] : null;
      note.textContent = 'Rough starting point only—not a precise fit prediction. Chest/shoulder shape changes sizing a lot.'
        + (next ? ' Also compare ' + next + ' if you want extra room.' : '')
        + (data.tall ? ' Check garment length carefully for taller frames.' : '');
    } else {
      note.textContent = 'Based on ' + data.source + '. ' + (fit === 'relaxed' ? 'Sized up for extra room.' : 'Closer modern fit.') + ' Compare the chart below.';
    }
    const row = get('[data-shadow-size="' + sizes[index] + '"]');
    if (row) row.classList.add('is-recommended');
  }

  root.querySelectorAll('[data-shadow-measure],[data-shadow-fit],[data-shadow-unit],[data-shadow-build]').forEach(button => {
    button.addEventListener('click', () => {
      if (button.hasAttribute('data-shadow-measure')) method = button.dataset.shadowMeasure;
      if (button.hasAttribute('data-shadow-fit')) fit = button.dataset.shadowFit;
      if (button.hasAttribute('data-shadow-build')) build = button.dataset.shadowBuild;
      if (button.hasAttribute('data-shadow-unit')) {
        const next = button.dataset.shadowUnit;
        syncUnits(unit,next);
        unit = next;
      }
      syncControls();
      renderChart();
      renderFinder();
    });
  });
  [field,feet,inches,cmHeight,weight].forEach(input => input.addEventListener('input', renderFinder));
  syncControls();
  renderChart();
  renderFinder();

    }
    releaseScroll() {
      if (!document.querySelector('.shadow-product-fit__dialog[open]')) document.documentElement.classList.remove('shadow-product-fit-open');
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.releaseScroll();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
